import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FavoritesState } from '../reducers/favorites.reducer';

export const selectFavoritesState = createFeatureSelector<FavoritesState>('favorites');

export const selectFavoriteItems = createSelector(selectFavoritesState, (state: FavoritesState) => state.favorites);

export const selectFavoritesError = createSelector(selectFavoritesState, (state: FavoritesState) => state.error);

export const selectFavoritesIsLoaded = createSelector(selectFavoritesState, (state: FavoritesState) => state.isLoaded);
